import {createStore} from "effector";

export const $requestsList = createStore([])
